import React, {ReactNode} from "react";
import {Box, makeStyles, Typography} from "@material-ui/core";
import LoginLink from "view/SignUp/SignUpToken/components/LoginLink";
import {ValidateExhibitorResponse} from "view/SignUp/SignUpToken/context/types";
import Alert from "view/components/Alert";

import reactStringReplace from "react-string-replace";

const useStyles = makeStyles(({spacing}) => ({
  alert: {
    display: "flex",
    alignItems: "center",
    borderRadius: 8,
    padding: spacing(2, 1, 2, 2),
    "& .MuiAlert-message": {
      minWidth: 0,
    },
  },
  message: {
    display: "flex",
    alignItems: "center",
  },
  // The API separates paragraphs with a blank line.
  text: {
    whiteSpace: "pre-line",
  },
}));

type Props = {
  result: ValidateExhibitorResponse;
  /** The console's translation for `result.reason`, shown instead of the API's English. */
  children?: ReactNode;
  /**
   * Present only when a connected Google account can sign straight into the
   * account that already holds this stand. The API has worded the message for
   * that case; this turns its "Continue to your account" into the link.
   */
  onContinueToAccount?: () => void;
  isContinuing?: boolean;
};

const ErrorMessage = ({
  result,
  children,
  onContinueToAccount,
  isContinuing = false,
}: Props) => {
  const classes = useStyles();

  if (result.status === "success") {
    return null;
  }

  const {message} = result;

  const continueToAccount = () => {
    if (!isContinuing) onContinueToAccount?.();
  };

  const withLoginLink = reactStringReplace(
    message,
    /(Log in to FFAIR platform|log in)/,
    (match, i) => <LoginLink key={`log-in-${i}`}>{match}</LoginLink>
  );
  const errorMessage = onContinueToAccount
    ? reactStringReplace(
        withLoginLink,
        "Continue to your account",
        (match, i) => (
          <LoginLink key={`continue-${i}`} onClick={continueToAccount}>
            {match}
          </LoginLink>
        )
      )
    : withLoginLink;

  return (
    <Alert severity={result.status} className={classes.alert}>
      <Box className={classes.message}>
        {" "}
        <Typography variant="h4" className={classes.text}>
          {" "}
          {children ?? errorMessage}
        </Typography>
      </Box>
    </Alert>
  );
};

export default ErrorMessage;
